export default __webpack_public_path__ + "static/media/rr.e190f2b3.webp";